import React from 'react';
import { Globe } from 'lucide-react';
import * as Flags from 'country-flag-icons/react/3x2';
import { nameToIsoCode } from '../../utils/countryIso';

// Renders a country flag from the `country-flag-icons` package, resolved from the
// country NAME. Flags are no longer uploaded/stored as images — they're derived
// automatically from the country name. Falls back to a Globe icon when the name
// can't be resolved to an ISO 3166-1 alpha-2 code.
const CountryFlag = ({ countryName, alt = '', className = 'w-5 h-5 rounded-sm object-cover' }) => {
    const code = nameToIsoCode(countryName);
    const Flag = code ? Flags[code] : null;
    const label = alt || countryName || '';

    if (!Flag) {
        return <Globe data-testid="country-flag-fallback" className={`${className} text-gray-400`} aria-label={label} />;
    }

    return (
        <Flag
            data-testid="country-flag-image"
            title={label}
            aria-label={label}
            className={className}
        />
    );
};

export default CountryFlag;
